<template>
  <v-sheet
    style="background: white"
    class="fill-height d-flex justify-space-around"
  >
    <v-snackbar
      :value="showMessage()"
      multi-line
      color="#686868"
      top
      
    >
      {{message}}
    </v-snackbar>
    <v-overlay opacity="0">
      <v-card style="width: 350px" color="#ffffff00" elevation="0" class="mt-0">
        <v-img
          class="mt-0"
          src="../assets/flat.png"
          height="200"
          contain
          >
        </v-img>
        <h5 class="text-center subtitle-1 grey--text font-weight-normal">
          A token has been sent to your email. Enter the token below.
        </h5>
        <v-form fluid ref="form" v-model="valid" lazy-validation name="form">
          <v-container>
            <v-text-field
              light
              color="#2A353D"
              prepend-inner-icon="mdi-shield-key"
              v-model="jwt.secret"
              label="Token"
              outlined
              required
              @keyup.enter="Signin()"
              :rules="fieldRules"
            ></v-text-field>
            <v-btn @click="loading = true; Signin()" class="btn btn-primary btn-block" color="#2A353D">
              <span v-show="loading" class="spinner-border spinner-border-sm mr-1"></span>
              <span class="white--text font-weight-bold">Submit</span>
            </v-btn>
          </v-container>
        </v-form>
      </v-card>
    </v-overlay>
  </v-sheet>
</template>

<script>

export default {
  data() {
    return {
      loading: false,
      message: '',
      jwt: {},
      fieldRules: [
        v => !!v || 'Field is required'
      ],
    };
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
  },
  created() {
    if (this.loggedIn) {
      this.$router.push('/home');
    }
  },
  methods: {
    Signin() {
      this.message = ''

      if(this.$route.params.token){
        this.loading = true;
        this.jwt.token = this.$route.params.token
        this.$store.dispatch('auth/signin', this.jwt).then(
          async () => {
            this.$router.push('/home'),
            Promise.all([
              this.$store.dispatch('getAllApplicationDefaults'),
              this.$store.dispatch('getSystemDate'),
              this.$store.dispatch('getAllImages'),
              this.$store.dispatch('getAllActivations'),
              this.$store.dispatch('getAllBankAccountTypes'),
              this.$store.dispatch('getAllBankBranches'),
              this.$store.dispatch('getAllFundAccountTypes'),
              this.$store.dispatch('getAllOffices'),
              this.$store.dispatch('getAllNMIRebates'),
              this.$store.dispatch('getAllBanks'),
              this.$store.dispatch('getAllBondInvestmentTypes'),
              this.$store.dispatch('getAllCallAccountTypes'),
              this.$store.dispatch('getAllCountries'),
              this.$store.dispatch('getAllCities'),
              this.$store.dispatch('getAllClientTypes'),
              this.$store.dispatch('getAllCurrencies'),
              this.$store.dispatch('getAllDealerGroups'),
              this.$store.dispatch('getAllDeliveryMethods'),
              this.$store.dispatch('getAllDepositMethods'),
              this.$store.dispatch('getAllFinancialYears'),
              this.$store.dispatch('getAllFrequencies'),
              this.$store.dispatch('getAllHolidays'),
              this.$store.dispatch('getAllIdentityTypes'),
              this.$store.dispatch('getAllOverrideReasons'),
              this.$store.dispatch('getAllPropertyTypes'),
              this.$store.dispatch('getAllRejectionReasons'),
              this.$store.dispatch('getAllSectors'),
              this.$store.dispatch('getAllAccountStatuses'),
              this.$store.dispatch('getAllCustodianStatuses'),
              this.$store.dispatch('getAllPropertyStatuses'),
              this.$store.dispatch('getAllExchangePairs'),
              this.$store.dispatch('getAllTitles'),
              this.$store.dispatch('getAllTransactionCodes'),
              this.$store.dispatch('getAllPermissions'),
              this.$store.dispatch('getAllUsers'),
              this.$store.dispatch('getAllRoles'),
              this.$store.dispatch('getAllInvalidPasswords'),
              this.$store.dispatch('getSettings'),
              this.$store.dispatch('getAllInstrumentTypes'),
              this.$store.dispatch('getAllCounterpartyLimits'),
              this.$store.dispatch('getAllCounterparties'),
              this.$store.dispatch('getAllDealerLimits'),
              this.$store.dispatch('getAllTaxRates'),
              this.$store.dispatch('getAllTaxes'),
              this.$store.dispatch('getAllFees'),
              this.$store.dispatch('getAllMMRates'),
              this.$store.dispatch('getAllClients'),
              this.$store.dispatch('getAllClientAccounts'),
              this.$store.dispatch('getAllClientContacts'),
              this.$store.dispatch('getAllClientSignatories'),
              this.$store.dispatch('getAllApplicationModules'),
              this.$store.dispatch('getAllTransactionCharges'),
              this.$store.dispatch('getAllPeriods'),
              this.$store.dispatch('getAllBackdatingLimitPeriods'),
              this.$store.dispatch('getAllUnitsRounding'),
              this.$store.dispatch('getAllTransactions'),
              this.$store.dispatch('getAllPurchases'),
              this.$store.dispatch('getAllSales'),
              this.$store.dispatch('getAllReversals'),
              this.$store.dispatch('retrieveBonds'),
              this.$store.dispatch('retrieveProperties'),
              this.$store.dispatch('retrievePropertyValues'),
              this.$store.dispatch('retrieveDealers'),
              this.$store.dispatch('retrieveCounters'),
              this.$store.dispatch('retrieveUnlistedCounters'),
              this.$store.dispatch('getAllCustodians'),
              this.$store.dispatch('getAllKYCDocuments'),
              this.$store.dispatch('getAllComDocuments'),
              this.$store.dispatch('getAllDecDocuments'),
              this.$store.dispatch('getAllIndDocuments'),
              this.$store.dispatch('getAllParDocuments'),
              this.$store.dispatch('getAllPenDocuments'),
              this.$store.dispatch('getAllTruDocuments'),
              this.$store.dispatch('getAllRDCDocuments'),
              this.$store.dispatch('getAllPtlDocuments'),
              this.$store.dispatch('getAllMunDocuments'),
              this.$store.dispatch('getAllNGODocuments'),
              this.$store.dispatch('getAllCCODocuments'),
              this.$store.dispatch('getIdentity'),
              this.$store.dispatch('getAllEquities'),
              this.$store.dispatch('getAllTransactionchargerate'),
              this.$store.dispatch('getApplicationFunctions'),
              this.$store.dispatch('getStockExchanges'),
              this.$store.dispatch('getAllEventMappings'),
              this.$store.dispatch('getAllEvents'),
              this.$store.dispatch('getAllProfileTypes'),
              this.$store.dispatch('getAllEquityprices'),
              this.$store.dispatch('getAllUlEquities'),
              this.$store.dispatch('getAllUlEquityprices'),
              this.$store.dispatch('getAllAssetTransfersEquity'),
              this.$store.dispatch('retrieveDailyExchanges'),
              this.$store.dispatch('getAllCorpEvents'),
              this.$store.dispatch('retrieveConfirmationSettings'),
              this.$store.dispatch('retrieveUnitTrustFunds'),
              this.$store.dispatch('retrieveUnitTrustDeals'),
              this.$store.dispatch('retrieveUnitDistributions')
            ]).finally(() => {
              this.$root.$emit("Initialised")
            })
          },
          error => {
            this.loading = false;
            this.message =
              (error.response && error.response.data.message) ||
              error.message ||
              error.toString();
          }
        );
      }
    },

    showMessage(){
      if(this.message){
        return true
      } else {
        return false
      }
    },
  },

  mounted(){
  }
};
</script>

<style scoped>

.text {
  color: #1C284E;
}

.v-btn {
  outline: none
}

</style>